import VueMoment from 'vue-moment'
import moment from 'moment-business-days'

moment.locale('en')
moment.updateLocale('en', {
  workingWeekdays: [ 1, 2, 3, 4, 5 ]
})

export { moment }
export default {
  install (Vue) {
    Vue.use(VueMoment, {
      moment
    })
  }
}
